export default "__VITE_ASSET__BJhDiNkY__"